import * as React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Paper } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import { alpha, Theme, SxProps } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

interface ISearchBoxProps {
  sxProps?: SxProps<Theme>;
  handleChange?: Function;
}

const SearchBox: React.FunctionComponent<ISearchBoxProps> = ({
  sxProps = {},
  handleChange,
}) => {
  const [search, setSearch] = React.useState("");
  const { t } = useTranslation();
  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    if (handleChange) handleChange(e.target.value);
  };
  return (
    <Paper
      component="form"
      onSubmit={(event) => event.preventDefault()}
      sx={{
        p: 1,
        display: "flex",
        alignItems: "center",
        boxShadow: "none",
        borderRadius: "16px",
        border: "1px solid",
        borderColor: (t) => alpha(t.palette.common.black, 0.12),
        [`& .MuiInputBase-root`]: {
          width: "100%",
        },
        ...sxProps,
      }}
    >
      <SearchIcon
        sx={{ mr: 1, color: (t) => alpha(t.palette.common.black, 0.3) }}
      />
      <InputBase placeholder={t("do_a_search")} onChange={handleChangeSearch} />
    </Paper>
  );
};

export default SearchBox;
